// @noflow
import { getSelectedDayHeight, getTimeAxisHeight, getWeekHeight } from '../utils';
import {
    LowerLine,
    Path,
    ScaleGroup,
    SliderClickArea,
    SliderElement,
    StartDot,
    TimeContainer,
    TimeLabel,
    UpperLine
} from './style';

import ImmutablePropTypes from 'react-immutable-proptypes';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import * as React from 'react';
import { SLIDER_Y } from '../constants';

const MINUTES_IN_DAY = 1440;

Slider.propTypes = {
    height: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    numEventsInSelectedDay: PropTypes.number.isRequired,
    onEnd: PropTypes.func.isRequired,
    onMove: PropTypes.func.isRequired,
    onStart: PropTypes.func.isRequired,
    selectedDay: PropTypes.number.isRequired,
    selectedEvent: ImmutablePropTypes.contains({
        eventIndex: PropTypes.number.isRequired,
        start: PropTypes.number.isRequired
    }).isRequired,
    temporaryStartTime: PropTypes.number,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired
};

export default function Slider({
    height,
    isDragging,
    numEventsInSelectedDay,
    onEnd,
    onMove,
    onStart,
    selectedDay,
    selectedEvent,
    temporaryStartTime,
    top,
    width
}) {
    const sliderHeight = getTimeAxisHeight(height);
    const halfSliderHeight = sliderHeight / 2;
    const start = temporaryStartTime || selectedEvent.get('start');
    const xPos = sliderHeight + Math.round(start * width / MINUTES_IN_DAY);
    const { otherDayHeight, selectedDayHeight } = getSelectedDayHeight(getWeekHeight(height), numEventsInSelectedDay);
    const yPos = Math.round(
        otherDayHeight * selectedDay +
            (selectedEvent.get('eventIndex') + 1.5) * selectedDayHeight / numEventsInSelectedDay
    );
    const deltaYTimeLabel = -yPos - halfSliderHeight;

    const showSliderAbove = top + yPos + SLIDER_Y + halfSliderHeight > height;

    const arrowLength = sliderHeight / 6;
    const leftArrowPath = `
		M ${-sliderHeight / 5} ${-arrowLength}
		l ${-arrowLength} ${arrowLength}
		l ${arrowLength} ${arrowLength}
	`;
    const rightArrowPath = `
		M ${sliderHeight / 5} ${-arrowLength}
		l ${arrowLength} ${arrowLength}
		l ${-arrowLength} ${arrowLength}
	`;
    const joinPath = `M ${-sliderHeight / 3} 0 h ${2 * sliderHeight / 3}`;

    return (
        <g
            style={{ transform: `translate3d(${xPos}px, ${top + yPos}px, 0)` }}
            transform={`translate(${xPos} ${top + yPos})`}
        >
            <UpperLine d={`M0 0 v ${deltaYTimeLabel}`} />
            {!showSliderAbove && <LowerLine d={`M0 0 v ${SLIDER_Y}`} />}
            <StartDot r="4" />
            <g
                data-qa="schedule-slider"
                style={{
                    transform: `translate3d(0, ${SLIDER_Y * (showSliderAbove ? -1 : 1)}px, 0)`
                }}
                transform={`translate(0 ${SLIDER_Y * (showSliderAbove ? -1 : 1)})`}
            >
                <ScaleGroup>
                    <SliderElement
                        height={sliderHeight}
                        rx={halfSliderHeight}
                        ry={halfSliderHeight}
                        width={sliderHeight * 2}
                        x={-sliderHeight}
                        y={-halfSliderHeight}
                    />
                    <Path d={leftArrowPath} />
                    <Path d={rightArrowPath} />
                    <Path d={joinPath} />
                    <SliderClickArea
                        height={sliderHeight}
                        isDragging={isDragging}
                        onMouseDown={e => onStart(e.clientX)}
                        onMouseLeave={onEnd}
                        onMouseMove={e => onMove(e.clientX)}
                        onMouseUp={onEnd}
                        onTouchEnd={onEnd}
                        onTouchMove={e => onMove(e.targetTouches[0].clientX)}
                        onTouchStart={e => onStart(e.targetTouches[0].clientX)}
                        width={sliderHeight * 2}
                        x={-sliderHeight}
                        y={-halfSliderHeight}
                    />
                </ScaleGroup>
            </g>
            <g
                data-qa="schedule-time-displayed"
                style={{ transform: `translate3d(0, ${deltaYTimeLabel}px, 0)` }}
                transform={`translate(0 ${deltaYTimeLabel})`}
            >
                <ScaleGroup>
                    <TimeContainer
                        height={sliderHeight}
                        rx={halfSliderHeight}
                        ry={halfSliderHeight}
                        width={sliderHeight * 2}
                        x={-sliderHeight}
                        y={-halfSliderHeight}
                    />
                    <TimeLabel dy="6">
                        {moment
                            .utc(0)
                            .minutes(start)
                            .format('LT')}
                    </TimeLabel>
                </ScaleGroup>
            </g>
        </g>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/slider/component.js